import PropTypes from 'prop-types';
import React from 'react';

import SingleSelectFilter from './filters/SingleSelectFilter';
import LabeledSelectFilter from './filters/LabeledSelectFilter';
import DebouncedSearchFilter from './filters/DebouncedSearchFilter';
import MultiSelectFilter from './filters/MultiSelectFilter';
import DateRangeFilter from './filters/DateRangeFilter';
import RangeFilter from './filters/RangeFilter';
import CheckBoxesFilter from './filters/CheckBoxesFilter';
import TextFilter from './filters/TextFilter';

const numberOfFiltersWithValue = (filters) => {
  return filters.reduce(function(total, filter){
    if(filter.value.length > 0){
      total = (total + 1);
    }

    return total;
  }, 0);
}

const components = {
  SingleSelectFilter: SingleSelectFilter,
  LabeledSelectFilter: LabeledSelectFilter,
  DebouncedSearchFilter: DebouncedSearchFilter,
  MultiSelectFilter: MultiSelectFilter,
  DateRangeFilter: DateRangeFilter,
  RangeFilter: RangeFilter,
  CheckBoxesFilter: CheckBoxesFilter,
  TextFilter: TextFilter
};

const FilterPanel = ({ filters, updateFilter, debouncedUpdateFilter, clearFilterValues, hiddenFilterParams = [] }) => {
  const visibleFilters = filters.filter(f => !hiddenFilterParams.includes(f.paramName));

  return (
  <div>
    <div className="row dataTable-filter-row">
      {visibleFilters.length > 0 ? (
        <div className="col-12 col-md px-3 pb-3 pt-0 filters-col">
          {visibleFilters.map((filter, i) =>
            React.createElement(components[filter.type], {key: i, filter: filter, updateFilter: updateFilter, debouncedUpdateFilter: debouncedUpdateFilter})
          )}
        </div>
      ) : null}
      <div className="col-12 col-md-auto px-3 pb-3 pt-0 clear-filters-col">
        <div style={{"marginTop": "8px"}}>
          <a href="#"
            onClick={(e) => {e.preventDefault(); clearFilterValues();}}
            className={"btn strong " + (numberOfFiltersWithValue(filters) === 0 ? "disabled" : "")}>
            Clear all filters ({numberOfFiltersWithValue(filters)})
          </a>
        </div>
      </div>
    </div>
  </div>
  );
};

FilterPanel.propTypes = {
  filters: PropTypes.array,
  updateFilter: PropTypes.func.isRequired,
  debouncedUpdateFilter: PropTypes.func.isRequired,
  clearFilterValues: PropTypes.func.isRequired,
  hiddenFilterParams: PropTypes.array
};

export default FilterPanel;
